import {
  ITEM_TYPE_OPTIONS,
  UNIT_SUGGESTIONS
} from '../../../../../../../constants/inventoryLabels'

const InventoryItemFormFields = ({ form, onChange }) => (
  <>
    <div className='grid grid-cols-1 gap-2 sm:grid-cols-2'>
      <div>
        <label className='mb-1 block text-xs font-semibold text-slate-700'>SKU</label>
        <input
          type='text'
          value={form.sku}
          onChange={event => onChange(prev => ({ ...prev, sku: event.target.value }))}
          className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
          placeholder='Ej: SKU-001'
        />
      </div>
      <div>
        <label className='mb-1 block text-xs font-semibold text-slate-700'>Unidad base</label>
        <select
          value={form.unit}
          onChange={event => onChange(prev => ({ ...prev, unit: event.target.value }))}
          className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
        >
          <option value=''>Seleccionar unidad base</option>
          {UNIT_SUGGESTIONS.map(unit => (
            <option key={unit} value={unit}>
              {unit}
            </option>
          ))}
        </select>
        <p className='mt-1 text-xs text-slate-500'>
          Define cómo se guarda el stock del item en inventario. Sólo se permite UN, KG o LT.
        </p>
      </div>
    </div>

    <div>
      <label className='mb-1 block text-xs font-semibold text-slate-700'>Nombre</label>
      <input
        type='text'
        value={form.name}
        onChange={event => onChange(prev => ({ ...prev, name: event.target.value }))}
        className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
        placeholder='Ej: Harina Integral 1 Kg'
      />
    </div>

    <div className='grid grid-cols-1 gap-2 sm:grid-cols-2'>
      <div>
        <label className='mb-1 block text-xs font-semibold text-slate-700'>Tipo de item</label>
        <select
          value={form.itemType}
          onChange={event => onChange(prev => ({ ...prev, itemType: event.target.value }))}
          className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
        >
          {ITEM_TYPE_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className='mb-1 block text-xs font-semibold text-slate-700'>Precio</label>
        <input
          type='number'
          min='0'
          value={form.price}
          onChange={event => onChange(prev => ({ ...prev, price: event.target.value }))}
          className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
          placeholder='Ej: 14990'
        />
      </div>
    </div>

    <div className='grid grid-cols-1 gap-2'>
      <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-2 text-sm text-slate-700'>
        <input
          type='checkbox'
          checked={form.controlsInventory}
          onChange={event => onChange(prev => ({ ...prev, controlsInventory: event.target.checked }))}
          className='mt-0.5'
        />
        <span>
          <span className='block font-medium'>Controla inventario</span>
          <span className='text-xs text-slate-500'>Si está marcado, este item afectará el stock.</span>
        </span>
      </label>
      <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-2 text-sm text-slate-700'>
        <input
          type='checkbox'
          checked={form.usesRecipe}
          onChange={event => onChange(prev => ({ ...prev, usesRecipe: event.target.checked }))}
          className='mt-0.5'
        />
        <span>
          <span className='block font-medium'>Usa receta</span>
          <span className='text-xs text-slate-500'>Úsalo si este producto se arma con otros insumos.</span>
        </span>
      </label>
      <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-2 text-sm text-slate-700'>
        <input
          type='checkbox'
          checked={form.active}
          onChange={event => onChange(prev => ({ ...prev, active: event.target.checked }))}
          className='mt-0.5'
        />
        <span>
          <span className='block font-medium'>Activo</span>
          <span className='text-xs text-slate-500'>Permite usar este item en inventario y ventas.</span>
        </span>
      </label>
    </div>
  </>
)

export default InventoryItemFormFields
